import React from 'react'

export const RemoteStockLabel = (
  {
    remoteStockName,
    isCurrentStage,
    stageStep
  }) => {

  if (!remoteStockName || !stageStep) return null
  if(stageStep !== 2 && isCurrentStage) return null

  return (
    remoteStockName && (
      <div className='text-Regular(12_14) bg-Accent/Yellow mt-[0.8rem] p-[3px] border-1 rounded-[4px] flex justify-center'>
        {remoteStockName}
      </div>
    )
  )
}